/* eslint no-param-reassign: "off" */
import config from '@/config';

export default {
  install(Vue, options) {
    Vue.prototype.$essentia = {
      path(params) {
        const path = !Array.isArray(params) ? params : params.join('/');
        // eslint-disable-next-line no-undef
        const local = typeof (g_local) !== 'undefined' && g_local;
        // eslint-disable-next-line no-undef
        const test = typeof (g_test) !== 'undefined' && g_test;
        const dev = process.env.NODE_ENV === 'development' && local;
        const serverConfig = test ? config.server_test : config.server;
        const server = dev ? config.server_development : serverConfig;
        return `${server}/${path}`;
      },
      filePath(data) {
        if (!data || !data.path) return null;
        if (data.source === 'local') {
          return this.path(data.path);
        }
        return data.path;
      },
      location() {
        const location = window.location.href.split('#')[0];
        return location.replace(/\/+$/g, '');
      },
      headers() {
        const { token } = options.store.state.data;
        return {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
          'Connection': 'Keep-Alive',
          'Keep-Alive': 'timeout=60',
        };
      },
      async fetch(path, body, commit) {
        const url = this.path(path);
        this.setLoading(true);
        const opts = { method: 'PUT', headers: this.headers(), body: JSON.stringify(body) };
        const response = await fetch(url, opts).catch((message) => ({ ok: false, message }));
        this.setLoading(false);
        if (response.ok) {
          try {
            const answer = await response.json();
            if (commit) {
              options.store.commit(commit, answer.message);
            }
            return answer;
          } catch (e) {
            console.log('Can_not_parse:', e);
            console.log(response);
            this.reportWarning('Can_not_parse');
            return null;
          }
        } else {
          const answer = await response.json();
          console.log('Error: ', answer.message);
          this.reportWarning(answer.message);
          return null;
        }
      },
      async sleep(ms) {
        return new Promise((resolve) => setTimeout(resolve, ms || 1500));
      },
      async connect(username, password) {
        const credentials = btoa(JSON.stringify([encodeURI(username), encodeURI(password)]));
        const opts = { method: 'PUT', headers: this.headers() };
        opts.headers.Authorization = `Basic ${credentials}`;
        const url = this.path('sign-in');
        const response = await fetch(url, opts).catch((message) => ({ ok: false, message }));
        if (response.ok) {
          return (await response.json()).message;
        }
        return false;
      },
      async get(entity, fields, conditions, parameters) {
        const answer = await this.fetch(['get', entity], { fields, conditions, parameters });
        return answer.message;
      },
      entity(entity, fields, conditions, parameters) {
        return this.fetch(['get', entity], { fields, conditions, parameters });
      },
      set(entity, values, conditions) {
        return this.fetch(['set', entity], { values, conditions }, 'backend/reportSaved');
      },
      add(entity, values, conditions, tmp) {
        return this.fetch(['add', entity], { values, conditions, tmp }, 'backend/reportInserted');
      },
      del(entity, id) {
        return this.fetch(['del', entity], id);
      },
      reportWarning(message) {
        options.store.commit('backend/reportWarning', message);
      },
      setLoading(loading) {
        options.store.commit('backend/loading', loading ? +1 : -1);
      },
     };
  }
};
